import { calcSignalStrength } from '@apps-common/utils/helpers'
import { useMemo } from 'react'
import { BiNoSignal, BiSignal1, BiSignal2, BiSignal3, BiSignal4, BiSignal5 } from 'react-icons/bi'

export const useSignalStrengthIcon: any = (value = -1) => {
  const signalValue = useMemo(() => {
    if (Number.isNaN(value)) {
      return -1
    }

    return calcSignalStrength(value)
  }, [value])

  const iconValue: any = useMemo(() => {
    if (signalValue >= 9) {
      return {
        Icon: (
          <div className='relative flex items-center justify-center text-text'>
            <BiSignal5 />
            <BiSignal5 className='absolute opacity-20' />
          </div>
        ),
        color: 'text-on-success',
        bg: 'bg-success'
      }
    }
    if (signalValue >= 7) {
      return {
        Icon: (
          <div className='relative flex items-center justify-center text-text'>
            <BiSignal4 />
            <BiSignal5 className='absolute opacity-20' />
          </div>
        ),
        color: 'text-on-success',
        bg: 'bg-success'
      }
    }
    if (signalValue >= 5) {
      return {
        Icon: (
          <div className='relative flex items-center justify-center text-text'>
            <BiSignal3 />
            <BiSignal5 className='absolute opacity-20' />
          </div>
        ),
        color: 'text-on-info',
        bg: 'bg-info'
      }
    }
    if (signalValue >= 3) {
      return {
        Icon: (
          <div className='relative flex items-center justify-center text-text'>
            <BiSignal2 />
            <BiSignal5 className='absolute opacity-20' />
          </div>
        ),
        color: 'text-on-warning',
        bg: 'bg-warning'
      }
    }
    if (signalValue >= 1) {
      return {
        Icon: (
          <div className='relative flex items-center justify-center text-text'>
            <BiSignal1 />
            <BiSignal5 className='absolute opacity-20' />
          </div>
        ),
        color: 'text-on-error',
        bg: 'bg-error'
      }
    }

    return {
      Icons: <BiNoSignal className='text-text' />,
      Icon: (
        <div className='relative flex items-center justify-center text-text'>
          <BiNoSignal />
          <BiNoSignal className='absolute opacity-20' />
        </div>
      ),
      color: 'text-text-muted',
      bg: 'bg-text-muted/20'
    }
  }, [signalValue])

  return iconValue
}
